export default "__VITE_ASSET__DtIlHTbO__"